<template>
  <div class="table">
    <div class="container">
      <el-form :model="formData" :rules="rules" ref="formData" :label-position="labelPosition" label-width="150px">
        <el-row>
          <!--SSR No.-->
          <el-col :span="8">
            <el-form-item :label="$t(`${type}Manage.${type}No`)" prop="ssrNo">
              <el-input class="de-input" disabled :value="formData.serialNo" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--创建人-->
          <el-col :span="8">
            <el-form-item :label="'Initiator'">
              <el-input class="de-input" :value="formData.creator" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!--创建日期-->
          <el-col :span="8">
            <el-form-item :label="'Creation Date'">
              <el-input :disabled="true" class="de-input" :value="formData.createDate | dateFormatFilter" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--Category1-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.category1')" prop="category1Id" :rules="rules.category1Id">
              <el-select :disabled="!canEditCategory" v-model="formData.category1Id" clearable @change="changeCategory1()">
                <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--Category2-->
          <el-col :span="8">
            <el-form-item :label="$t('ssrManage.category2')" prop="category2Id">
              <el-select :disabled="!canEditCategory" v-model="formData.category2Id" clearable>
                <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--状态-->
          <el-col :span="8">
            <el-form-item :disabled="!canEdit" :label="'Status'">
              <el-input class="de-input" :value="viewStatus|ic('TT_SSR','STATUS_VIEW')" clearable disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--SSR Name-->
          <el-col :span="20">
            <el-form-item :label="$t(`${type}Manage.${type}Name`)" prop="name">
              <el-input :disabled="!canEdit" class="de-input" v-model="formData.name" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--Product Description-->
          <el-col :span="20">
            <el-form-item :label="$t('ssrManage.description')">
              <el-input :disabled="!canEdit" class="de-input" v-model="formData.productDescription" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('ssrManage.marketScope')" prop="marketScope">
              <el-input type="textarea" maxlength="300" autosize :disabled="!canEdit" v-model="formData.marketScope" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t(`${type}Manage.${type}Objective`)" prop="ssrObjective">
              <el-input type="textarea" maxlength="300" autosize :disabled="!canEdit" v-model="formData.ssrObjective" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <span style="padding-right: 15px;">{{$t('ssrManage.supplierList')}}</span>
          <el-button v-if="canEdit" type="primary" @click="showSupplierDialog = true">New</el-button>
          <el-button v-if="canEdit" type="primary" @click="delSupplier">Delete</el-button>
        </div>
        <el-table :data="formData.ssrSupplierList" ref="supplierList" border highlight-current-row style="margin-top:15px;">
          <el-table-column v-if="canEdit" type="selection"></el-table-column>
          <!--供应商编号/邀请码-->
          <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('ssrManage.invitationCode')"></el-table-column>
          <!--供应商名称-->
          <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('ssrManage.supplierName')"></el-table-column>
          <!--联系人-->
          <el-table-column show-overflow-tooltip prop="contacts" :label="$t('ssrManage.contacts')" column-key="contacts">
            <template slot-scope="scope">
              <el-form-item :prop="`ssrSupplierList[${scope.$index}].contacts`" label-width="0" :rules="rules.supplierContacts">
                <el-input :disabled="!canEdit" v-model="scope.row.contacts" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <!--邮箱-->
          <el-table-column show-overflow-tooltip prop="email" :label="$t('ssrManage.email')" column-key="email">
            <template slot-scope="scope">
              <el-form-item :prop="`ssrSupplierList[${scope.$index}].email`" label-width="0" :rules="rules.supplierEmail">
                <el-input :disabled="!canEdit" v-model="scope.row.email" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <!--                    <el-table-column width="80" align="center" prop="lastRound" :label="$t('ssrManage.roundNum')">-->
          <!--                        <template slot-scope="scope">{{scope.row.lastRound|romanNum}}</template></el-table-column>-->
          <!--                    <el-table-column width="100" prop="roundStatus" :label="$t('ssrManage.supplierRoundStatus')">-->
          <!--                        <template slot-scope="scope">{{supplierStatus(scope.row)}}</template>-->
          <!--                    </el-table-column>-->
          <!--                    <el-table-column width="100" prop="submitDate" :label="$t('ssrManage.supplierRoundSubmitDate')">-->
          <!--                        <template slot-scope="scope">{{scope.row.submitDate|dateFormatFilter}}</template>-->
          <!--                    </el-table-column>-->
        </el-table>
        <div style="margin-top:15px;">Schedule of Events</div>
        <el-table :data="formData.events" ref="scheduleList" border highlight-current-row style="margin-top:15px;">
          <!--Project Item-->
          <el-table-column show-overflow-tooltip prop="projectItem" :label="$t('ssrManage.projectItem')">
            <template slot-scope="scope">
              <el-form-item label-width="0" v-if="canEdit && scope.row.canDel=='Y'" :prop="`events[${scope.$index}].projectItem`" :rules="rules.projectItem">
                <el-input v-model="scope.row.projectItem"></el-input>
              </el-form-item>
              <span v-else>{{scope.row.projectItem}}</span>
            </template>
          </el-table-column>
          <!--Timeline-->
          <el-table-column show-overflow-tooltip prop="startDate" :label="$t('ssrManage.beginDate')">
            <template slot-scope="scope">
              <el-form-item label-width="0" v-if="canEdit" :prop="`events[${scope.$index}].startDate`" :rules="rules.eventDeadline">
                <el-date-picker value-format="yyyy-MM-dd" :picker-options="{disabledDate:eventDisableStartDate(scope.$index)}" type="date" v-model="scope.row.startDate" />
              </el-form-item>
              <span v-else>{{scope.row.startDate | dateFormatFilter}}</span>
            </template>
          </el-table-column>
          <!--Timeline-->
          <el-table-column show-overflow-tooltip prop="deadline" :label="$t('ssrManage.timeline')">
            <template slot-scope="scope">
              <el-form-item label-width="0" v-if="canEdit" :prop="`events[${scope.$index}].deadline`" :rules="rules.eventDeadline">
                <el-date-picker value-format="yyyy-MM-dd" :picker-options="{disabledDate:eventDisableDate(scope.$index)}" type="date" v-model="scope.row.deadline" />
              </el-form-item>
              <span v-else>{{scope.row.deadline | dateFormatFilter}}</span>
            </template>
          </el-table-column>
          <!--Remark-->
          <el-table-column show-overflow-tooltip prop="proposal" :label="$t('ssrManage.remark')">
            <template slot-scope="scope">
              <el-form-item label-width="0" v-if="canEdit" :prop="`events[${scope.$index}].remark`" :rules="rules.remark">
                <el-input class="el-input__inner" v-model="scope.row.remark"></el-input>
              </el-form-item>
              <span v-else>{{scope.row.remark}}</span>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column show-overflow-tooltip width="280">
            <template slot-scope="scope">
              <el-button v-if="canEdit & scope.row.canDel=='Y'" type="primary" @click="delScheduleRow(scope.$index)">Delete</el-button>
              <el-button type="primary" v-if="canEdit" @click="addScheduleRow(scope.row,scope.$index,'up')">
                {{$t('ssrManage.upAdd')}}
              </el-button>
              <el-button type="primary" v-if="canEdit" @click="addScheduleRow(scope.row,scope.$index,'down')">
                {{$t('ssrManage.downAdd')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:15px;">
          <el-button type="primary" @click="ganttChartLoad">Gantt Chart</el-button>
        </div>
        <div v-show="!isSupplier" style="margin-top:15px;">Information</div>
        <el-table class="PQCP" v-show="!isSupplier" :data="informationList" ref="informationList" border highlight-current-row style="margin-top:15px;width: 500px;" :show-header="false">
          <el-table-column :selectable="()=>canEdit" type="selection"></el-table-column>
          <el-table-column prop="type"></el-table-column>
          <el-table-column prop="name">
            <template slot-scope="scope">
              <div v-if="scope.row.code=='needVolumeForecast'">
                <el-upload v-if="canEdit" :headers="uploadHeader" :show-file-list="false" :http-request="uploadVolumeForecast" multiple>
                  <el-button type="primary">Upload</el-button>
                </el-upload>
                <div v-for="(file,index) in formData.volumeForecastFiles" :key="index" style="line-height: 40px;">
                  <el-link type="primary" @click="downloadFile(file)">{{file.documentName}}</el-link>
                  <el-button v-if="canEdit" @click="delInformationDocs(file,'volumeForecastFiles',index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>
                </div>
              </div>
              <div v-else-if="scope.row.code=='needCapacityAnalysis'">
                <el-upload v-if="canEdit" :headers="uploadHeader" :show-file-list="false" :http-request="uploadCapacityAnalysis" multiple>
                  <el-button type="primary">Customize</el-button>
                </el-upload>
                <div v-for="(file,index) in formData.capacityAnalysisFiles" :key="index" style="line-height: 40px;">
                  <el-link type="primary" @click="downloadFile(file)">{{file.documentName}}</el-link>
                  <el-button v-if="canEdit" @click="delInformationDocs(file,'capacityAnalysisFiles',index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>
                </div>
              </div>
              <div v-else-if="scope.row.code=='needCostBreakdown'">
                <el-upload v-if="canEdit" :headers="uploadHeader" :show-file-list="false" :http-request="uploadCostBreakdown" multiple>
                  <el-button type="primary">Customize</el-button>
                </el-upload>
                <div v-for="(file,index) in formData.costBreakdownFiles" :key="index" style="line-height: 40px;">
                  <el-link type="primary" @click="downloadFile(file)">{{file.documentName}}</el-link>
                  <el-button v-if="canEdit" @click="delInformationDocs(file,'costBreakdownFiles',index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>
                </div>
              </div>
              <div v-else-if="scope.row.code=='needOtherFormat'">
                <el-upload v-if="canEdit" :headers="uploadHeader" :show-file-list="false" :http-request="uploadOtherFormat" multiple>
                  <el-button type="primary">Upload</el-button>
                </el-upload>
                <div v-for="(file,index) in formData.otherFormatFiles" :key="index" style="line-height: 40px;">
                  <el-link type="primary" @click="downloadFile(file)">{{file.documentName}}</el-link>
                  <el-button v-if="canEdit" @click="delInformationDocs(file,'otherFormatFiles',index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>
                </div>
              </div>
              <div v-if="scope.row.code=='needPqcp' || scope.row.code=='needLogisticCapacity'">
                <el-link type="primary" @click="downloadTemplate(scope.row.type)">{{$t('ssrManage.downloadTemplate')}}</el-link>
              </div>
            </template>
          </el-table-column>
          <!--                    <el-table-column prop="template" v-if="!isSupplier && (['DRAFT','MARKED'].indexOf(formData.status)>=0 || formData.status == null)">-->
          <!--                        <template slot-scope="scope" v-if="scope.row.code!='needVolumeForecast' && scope.row.code!='needOtherFormat'">-->
          <!--                            <el-link type="primary" @click="downloadTemplate(scope.row.type)">{{$t('ssrManage.downloadTemplate')}}</el-link>-->
          <!--                        </template>-->
          <!--                    </el-table-column>-->
        </el-table>
        <div v-if="showCostBreakdown" v-show="!isSupplier" style="margin-top:15px;">Cost Breakdown
          <el-button v-if="canEdit" type="primary" @click="addCostBreakdownList">Add</el-button>
        </div>
        <el-table v-if="showCostBreakdown" v-show="!isSupplier" :data="costBreakdownList" ref="costBreakdownList" border highlight-current-row style="margin-top:15px;width: 600px;" :show-header="false">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="type" width="250">
            <template slot-scope="scope">
              <el-form-item :prop="`costBreakdownColumns[${scope.$index}]`" :rules="rules.costBreakdown">
                <el-input style="width: 300px;" :disabled="!canEdit ||[0,1,2].indexOf(scope.$index)>=0|| scope.$index == (costBreakdownList.length-1)" v-model="scope.row.name"></el-input>
              </el-form-item>
              <i v-if="canEdit && scope.$index>0 && [0,1,2].indexOf(scope.$index)<0 && scope.$index < (costBreakdownList.length-1)" class="el-icon-top" @click="changeSort(scope.row,scope.$index,'up')" style="font-size: 18px;color: red;"></i>
              <i v-if="canEdit && [0,1,2].indexOf(scope.$index)<0 && scope.$index < (costBreakdownList.length-2)" class="el-icon-bottom" @click="changeSort(scope.row,scope.$index,'down')" style="font-size: 18px;padding-left: 15px;color: green;"></i>
            </template>
          </el-table-column>
          <el-table-column v-if="canEdit" prop="type" width="80">
            <template slot-scope="scope" v-if="canEdit && [0,1,2].indexOf(scope.$index)<0 && scope.$index < (costBreakdownList.length-1)">
              <el-link type="primary" @click="costBreakdownList.splice(scope.$index,1)">Delete</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="color: #ccc;"></div>
        <div style="margin-top:15px;">Corresponding CQS
          <pickup-category-leader :query-conditions="{type:'CQS'}" v-if="canEdit" @pickUp="addCqs" :multi="true" pick-type="1">Add</pickup-category-leader>
        </div>
        <el-table :data="correspondingList" ref="correspondingList" border highlight-current-row style="margin-top:15px;width: 500px;" :show-header="false">
          <el-table-column prop="name" :key="'cqsName'"></el-table-column>
          <el-table-column v-if="canEdit" width="200" :key="'cqsAction'">
            <template slot-scope="scope">
              <el-link type="primary" @click="correspondingList.splice(scope.$index,1)">Delete</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding-top: 15px;" v-if="correspondingList.length > 0">
          <el-checkbox :disabled="!canEdit" v-model="uploadSpec">Product Spec Required</el-checkbox>
        </div>
        <file-upload :show-title="false" @on-delete-success="afterDeleteSpec" @on-upload-success="afterUploadSuccess" v-if="uploadSpec && (correspondingList.length > 0)" v-model="formData.productSpecFiles" rec-type="SSR" :biz-id="formData.ttSsrId" seq="PRODUCT_SPEC" :multiple="true" :disabled="!canUploadSpec">
        </file-upload>
      </el-form>
      <!--底部操作按钮-->
      <el-row type="flex" justify="center" style="padding-top: 15px;">
        <el-button type="primary" v-if="canEdit" @click="preIssue()">{{$t('ssrManage.announce')}}</el-button>
        <el-button type="primary" v-if="canEdit" @click="save()">Save As Draft</el-button>
        <el-button type="primary" @click="routerBack">{{'Close'}}</el-button>
      </el-row>
    </div>
    <supplier-dialog :is-show.sync="showSupplierDialog" :create-fun="onSupplier" @hideDialog="showSupplierDialog = false" />
    <ssr-issue-dialog @issued="afterIssued()" :roundNumber="formData.currentRound" :mailTos="mailTos" :mailCcs="mailCcs" :mailBccs="mailBccs" :ssr-id="formData.ttSsrId" :is-show.sync="showIssueDialog" :create-fun="onIssue" @hideDialog="showIssueDialog = false" />
    <el-dialog title="Chart" :visible="showGantt" @close="showGantt = false">
      <Echart :scheduleList="formData.events" :eventActualDate="eventActualDate" :name="formData.name" :show="showGantt" :create-date="formData.createDate"></Echart>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import Moment from 'moment'
import commonMethods from "@/utils/commonMethods";
import supplierDialog from "@/components/page/ssr-manage/supplier-dialog";
import ssrIssueDialog from "@/components/page/ssr-manage/ssr-issue-dialog";
import commonFun from "@/utils/commonFun";
import { apiService as materialService } from "@/api/material/material-master-data";
import pickupUser from "@/components/common/pickupUser";
import Echart from "@/components/page/ssr-manage/echart";
import commonConstatns from "@/constants/commonConstants";
import { fileService } from "@/api/common/file-utils";
import FileUpload from "@/components/common/fileUpload";
import PickupCategoryLeader from "@/components/common/pickupCategoryLeader";

export default {
  name: 'ssr-manage-add',
  extends: commonMethods,
  props: {
    value: Object,
  },
  components: {
    PickupCategoryLeader,
    FileUpload,
    Echart,
    pickupUser,
    supplierDialog,
    ssrIssueDialog
  },
  computed: {
    viewStatus() {
      let status = this.formData.status;
      switch (status) {
        case 'DRAFT':
          return 'NEW';
        case 'MARKED':
        case 'SUPPLIER_SUBMIT':
        case 'ISSUED':
        case 'SUBMIT':
          return 'PROCESSING';
        case 'RECOMMENDATION':
          if (this.type.toUpperCase() == 'SSR') {
            return 'PROCESSING';
          } else if (this.type.toUpperCase() == "RFP") {
            return 'END';
          }
        case 'BC_CREATED':
        case 'FINISH':
          return 'END';
        case 'SUSPEND':
          return 'TERMINATION';
      }
    },
    type() {
      return this.$route.meta.type;
    },
    mailTos() {
      let that = this;
      let creator = commonFun.isEmpty(that.formData.creator) ? localStorage.getItem("ms_username") : that.formData.creator;
      let to = {
        name: creator,
        email: that.formData.creatorEmail
      };
      return [to];
    },
    mailCcs() {
      return this.correspondingList;
    },
    mailBccs() {
      let supplierList = commonFun.deepCopy(this.formData.ssrSupplierList.filter(sup => sup.status != "DISCONTINUED"));
      supplierList.forEach(sup => sup.name = sup.supplierName);
      return supplierList;
    },
    uploadHeader() {
      return { 'x-access-token': localStorage.getItem('token') };
    },
    volumeForecastFileUploadUrl() {
      return `${commonConstatns.fileUploadUrl}/SSR/PROPOSAL/${this.formData.ssrRoundSuppliers[0].ttSsrRoundSupplierId}`
    },
    otherFormatFileUploadUrl() {
      return `${commonConstatns.fileUploadUrl}/SSR/PROPOSAL/${this.formData.ssrRoundSuppliers[0].ttSsrRoundSupplierId}`
    },
    canEdit: function () {
      return ['ssr-manage-add', 'rfp-manage-add'].indexOf(this.$route.name) >= 0 || (this.formData.canEdit && ["DRAFT", "FINISH", "MARKED"].indexOf(this.formData.status) >= 0);
    },
    canEditCategory: function () {
      return this.canEdit && (commonFun.isEmpty(this.formData.currentRound) || this.formData.currentRound == 1);
    },
    showCostBreakdown: function () {
      if (this.isMounted) {
        return this.$refs['informationList'].selection.some(value => value.code == 'needCostBreakdown');
      }
    },
    needReload() {
      return this.$store.state.ssr.needReload;
    },
    canUploadSpec() {
      return (['DRAFT', 'MARKED'].indexOf(this.formData.status) >= 0) && this.correspondingList.some(cqs => cqs.tmUserId == localStorage.getItem("ms_userId"));
    },
    supplierStatus(sup) {
      return function (sup) {
        if (sup.roundStatus == "AWARD") {
          return this.$t("ssrManage.supStatusRecommendation");
        } else if (sup.status == 'REFUSE') {
          return this.$t("ssrManage.supStatusRefuse");
        } else if (sup.roundStatus == 'CONTINUE') {
          return this.$t("ssrManage.supStatusContinue");
        } else if (sup.roundStatus == 'DISCONTINUED') {
          return this.$t("ssrManage.supStatusDistinue");
        } else if (sup.status == 'REFUSE') {
          return this.$t("ssrManage.supStatusRefuse");
        } else if (sup.status == 'SUBMIT' || sup.roundStatus == 'SUBMIT') {
          return this.$t("ssrManage.supStatusSubmit");
        } else if (sup.status == 'NEW' || sup.status == 'DRAFT') {
          return this.$t("ssrManage.supStatusDraft");
        }
      }
    }
  },
  mounted() {
    this.isMounted = true;
  },
  data() {
    return {
      showGantt: false,
      isMounted: false,
      formData: {
        category1Id: null,
        category2Id: null,
        ssrName: null,
        supplierCode: '',
        supplierName: '',
        address: '',
        ssrSupplierList: [],
        events: [],
        currentRound: 1,
        otherFormatFiles: [],
        volumeForecastFiles: [],
        capacityAnalysisFiles: [],
        costBreakdownFiles: [],
        supplierCapacityFiles: [],
      },
      eventActualDate: [],
      categoryList1: [],
      categoryList2: [],
      labelPosition: 'right',
      showSupplierDialog: false,
      showIssueDialog: false,
      informationList: [
        { code: 'needPqcp', type: 'PQCP', name: 'Mandatory by tick' },
        { code: 'needCostBreakdown', type: 'Cost Breakdown', name: 'Mandatory by tick' },
        { code: 'needCapacityAnalysis', type: 'Capacity Analysis', name: 'Mandatory by tick' },
        { code: 'needVolumeForecast', type: 'Volume Forecast', name: 'Upload' },
        { code: 'needLogisticCapacity', type: 'Logistics Capacity', name: 'Mandatory by tick' },
        { code: 'needOtherFormat', type: 'Other Format', name: 'Mandatory by tick' },
      ],
      costBreakdownList: [],
      costBreakdownOption: [],
      correspondingList: [],
      correspondingOption: [],
      corresponding: [],
      costBreakdown: null,
      uploadSpec: false,
      rules: {
        name: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
        category1Id: [{ required: true, message: 'Can not be empty!', trigger: 'change' }],
        category2Id: [{ required: true, message: 'Can not be empty!', trigger: 'change' }],
        supplierContacts: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
        supplierEmail: [{
          validator: (rule, value, callback) => {
            if (commonFun.isEmpty(value)) {
              return callback(new Error('Can not be empty!'));
            }
            let reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if (!reg.test(value)) {
              callback(new Error('Enter the correct email address'));
            } else {
              callback();
            }
          }, required: true, trigger: 'blur'
        }],
        eventDeadline: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
        projectItem: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
        costBreakdown: [{
          validator: (rule, value, callback) => {
            if (commonFun.isEmpty(value)) {
              callback(new Error('Can not be empty!'));
            } else {
              callback();
            }
          }, trigger: 'blur'
        }],
      },
    }
  },
  created() {
    this.getCategoryList();
    this.init();
  },
  methods: {
    downloadTemplate: function (type) {
      apiService.downloadTemplate(type);
    },
    downloadFile: function (row) {
      if (this.$route.query.params === 'new') {
        this.$my_message('Please save as draft  before downloading', 'error')
      } else {
        fileService.downloadFile(row).then((res) => { })
      }
    },
    afterDeleteSpec(file, fileList) {
      if (fileList.length == 0) {
        apiService.updateSpecUploadStatus({
          ttSsrId: this.formData.ttSsrId,
          isSpecUpload: 'N'
        });
      }
    },
    afterUploadSuccess() {
      apiService.updateSpecUploadStatus({
        ttSsrId: this.formData.ttSsrId,
        isSpecUpload: 'Y'
      });
    },
    preIssue() {
      this.formatSsrData();
      let that = this;
      this.$refs.formData.validate(valid => {
        //系统校验当前页面必填项是否完成填写，未完成填写则弹窗提示
        if (valid) {
          if (commonFun.isEmpty(that.formData.ssrSupplierList)) {
            Message.error(that.$t("ssrManage.supplierListCannotBeEmpty"));
            return false;
          }
          that.save(true).then(() => {
            this.showIssueDialog = true;
          });
        } else {
          Message({ message: '数据填写不全', type: "warning" });
        }
      })
    },
    delInformationDocs(file, fileList, index) {
      let that = this;
      if (file.tmDocumentId == null) {
        that.formData[fileList].splice(index, 1);
      } else {
        fileService.deleteFile(file.tmDocumentId).then(value => {
          that.formData[fileList].splice(index, 1);
        })
      }
    },
    afterIssued() {
      let that = this;
      that.showIssueDialog = false;
      that.$router.push({ path: `/${that.type}-manage` });
    },
    init() {
      let that = this;
      let ssrId = this.$route.query.id;
      if (commonFun.isNotEmpty(ssrId)) {
        apiService.getDetail(ssrId).then(res => {
          res.data.ssrRounds.forEach(round => {
            if (commonFun.isNotEmpty(round.ssrRoundSupplierPqcps)) {
              round.ssrRoundSupplierPqcps.forEach(pqcp => {
                if (commonFun.isEmpty(pqcp.supplierDc)) {
                  pqcp.supplierDc = [];
                } else {
                  pqcp.supplierDc = JSON.parse(pqcp.supplierDc);
                }
              });
            }
            if (commonFun.isNotEmpty(round.ssrRoundSupplierPcns)) {
              round.ssrRoundSupplierPcns.forEach(pcn => {
                if (commonFun.isEmpty(pcn.supplierDc)) {
                  pcn.supplierDc = [];
                } else {
                  pcn.supplierDc = JSON.parse(pcn.supplierDc);
                }
              });
            }
          })
          that.formData = res.data;
          that.changeCategory1(true);
          that.informationList.forEach(information => {
            if (that.formData[information.code] == 'Y') {
              if (that.$refs.informationList) {
                that.$refs.informationList.toggleRowSelection(information);
              }
            }
          })
          if (that.formData.needCostBreakdown == 'Y') {
            that.costBreakdownList = that.formData.costBreakdownColumns.filter(column => column != null).map(column => {
              return { name: commonFun.trim(column) }
            });
            if (commonFun.isEmpty(that.costBreakdownList)) {
              that.costBreakdownList = [{ name: 'Total Cost' }];
            }
          }
          that.uploadSpec = that.formData.productSpec == 'Y';
          that.correspondingList = that.formData.ssrCqs;
          that.$store.dispatch("loadPost", res.data);
          that.$emit("update:ssr", res.data);
        });
      } else {
        that.$set(this.formData, "events", [
          { canDel: 'N', projectItem: `${this.type.toUpperCase()} Initiation` },
          { canDel: 'N', projectItem: 'Supplier Submit Proposal' },
          { canDel: 'N', projectItem: 'Recommendation' },
          { canDel: 'N', projectItem: 'Business Case' }])
        this.costBreakdownList = [
          { name: 'Item Name' },
          { name: 'Item Code' },
          { name: 'Unit（SU）' },
          { name: 'Raw Material' },
          { name: 'Packaging' },
          { name: 'Production Cost' },
          { name: 'Labor Cost' },
          { name: 'Management Cost' },
          { name: 'Tax Amount' },
          { name: 'Margin' },
          { name: 'Freight' },
          { name: 'Total Cost' },
        ];
      }
    },
    getCategoryList() {
      materialService.findCategory({ categoryLevel: 1, typeList: ['common', 'Logistic'] }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1(holdCategory2) {
      if (!!!holdCategory2) {
        this.formData.category2Id = null;
      }
      this.categoryList2 = []
      let that = this;
      if (commonFun.isNotEmpty(that.formData.category1Id)) {
        let categoryList = that.categoryList1.filter(item => item.tmCategoryId == that.formData.category1Id);
        if (categoryList[0].type == 'Logistic') {
          that.informationList.splice(0, 1, { code: 'needPcn', type: 'PQCP', name: 'Mandatory by tick' });
        } else {
          that.informationList.splice(0, 1, { code: 'needPqcp', type: 'PQCP', name: 'Mandatory by tick' });
        }
      }
      materialService.findCategory({ categoryLevel: 2, pid: that.formData.category1Id, typeList: ['common', 'Logistic'] }).then((res) => {
        that.categoryList2 = res.data;
      });
    },
    //删除供应商清单
    delSupplier() {
      let val = this.$refs.supplierList.selection;
      const supplierIds = val.map(item => item.tmSupplierId);
      if (supplierIds.length > 0) {
        for (const tmSupplierId of supplierIds) {
          for (var i = 0; i < this.formData.ssrSupplierList.length; i++) {
            if (tmSupplierId == this.formData.ssrSupplierList[i].tmSupplierId) {
              this.formData.ssrSupplierList.splice(i, 1);
            }
          }
        }
        this.$message({
          type: "success",
          message: 'Delete Success'
        });
      } else {
        this.$message({
          type: "error",
          message: 'Please select data!'
        });
      }
    },
    // 添加供应商
    onSupplier(data) {
      let that = this;
      let list = commonFun.deepCopy(data).filter(sup => !this.formData.ssrSupplierList.some(tmp => tmp.tmSupplierId == sup.tmSupplierId));
      list.forEach(sup => sup.status = "NEW");
      if (commonFun.isNotEmpty(list)) {
        list.forEach(item => {
          item.email = item.emailAddress;
          item.contacts = item.linkman;
        })
        this.formData.ssrSupplierList.push(...list);
      }
      this.showSupplierDialog = false
      this.$forceUpdate();
    },
    // Schedule of Events添加行
    addScheduleRow(data, index, type) {
      const item = { projectItem: null, canDel: 'Y' }
      //在指定位置添加元素,第一个参数指定位置,第二个参数指定要删除的元素,如果为0,则追加
      this.formData.events.splice(type === 'up' ? index : index + 1, 0, item);
    },
    // Schedule of Events删除行
    delScheduleRow(index) {
      //删除指定位置元素,第一个参数指定位置,第二个参数指定要删除的元素,如果为0,则追加
      this.formData.events.splice(index, 1);
    },
    // 甘特图
    ganttChartLoad() {
      if (commonFun.isEmpty(this.formData.events)
        || this.formData.events.some(value => commonFun.isEmpty(value.projectItem) || commonFun.isEmpty(value.deadline) || commonFun.isEmpty(value.startDate))) {
        Message({ message: 'Schedule of Events填写未完成', type: "warning" });
      } else {
        // let tmpData = null;
        // let errorFlag = false;
        // this.formData.events.forEach(schedule => {
        //     if (tmpData != null && tmpData > schedule.deadline) {
        //         errorFlag = true;
        //         return false;
        //     }
        //     tmpData = schedule.deadline;
        // });
        // if (errorFlag) {
        //     Message({message: this.$t('ssrManage.scheduleDateError'), type: "warning"})
        //     return false;
        // }

        let chartDatas = [];
        this.formData.events.forEach(event => {
          var item = {
            startDate: event.startDate,
            deadline: event.deadline,
          }
          chartDatas.push(item);
        });
        this.chartDatas = chartDatas;
        this.showGantt = true;
      }
    },
    // Cost Breakdown 添加
    addCostBreakdownList() {
      this.costBreakdownList.splice(-1, 0, { name: this.costBreakdown })
    },
    // Cost Breakdown 改变位置
    changeSort(row, index, type) {
      //先把这条数据移除
      this.costBreakdownList.splice(index, 1);
      //再把这条数据插入指定位置
      this.costBreakdownList.splice(type === 'up' ? index - 1 : index + 1, 0, row);
    },
    addCqs(users) {
      let that = this;
      let filter = users.filter(user => commonFun.isEmpty(that.correspondingList) || !that.correspondingList.some(cqs => cqs.tmUserId == user.tmUserId));
      this.correspondingList.push(...filter);
    },
    //保存
    save(isIssue) {
      let that = this;
      return apiService.save(this.formatSsrData()).then(res => {
        if (res.code == 200) {
          that.formData = res.data;
          if (!isIssue && that.$route.name == `${that.type}-manage-add`) {
            if (commonFun.isSupplier()) {
              that.$router.push({ path: `/${that.type}-detail-supp`, query: { id: res.data.ttSsrId } });
            } else {
              that.$router.push({ path: `/${that.type}-detail-ss`, query: { id: res.data.ttSsrId } });
            }
          }
        }
      });
    },
    uploadVolumeForecast(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      if (_this.formData.ttSsrId != null) {
        fileService.fileUploadWithReplationShip("SSR", _this.formData.ttSsrId, "VOLUME_FORECAST", formData).then((res) => {
          _this.formData.volumeForecastFiles.push(...res.data);
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          _this.formData.volumeForecastFiles.push(...res.data);
        });
      }
    },
    uploadCostBreakdown(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      if (_this.formData.ttSsrId != null) {
        fileService.fileUploadWithReplationShip("SSR", _this.formData.ttSsrId, "COST_BREAKDOWN", formData).then((res) => {
          _this.formData.costBreakdownFiles.push(...res.data);
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          _this.formData.costBreakdownFiles.push(...res.data);
        });
      }
    },
    uploadOtherFormat(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      if (_this.formData.ttSsrId != null) {
        fileService.fileUploadWithReplationShip("SSR", _this.formData.ttSsrId, "SSR_OTHER_FORMAT", formData).then((res) => {
          _this.formData.otherFormatFiles.push(...res.data);
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          _this.formData.otherFormatFiles.push(...res.data);
        });
      }
    },
    uploadCapacityAnalysis(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      if (_this.formData.ttSsrId != null) {
        fileService.fileUploadWithReplationShip("SSR", _this.formData.ttSsrId, "CAPACITY_ANALYSIS", formData).then((res) => {
          _this.formData.capacityAnalysisFiles.push(...res.data);
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          _this.formData.capacityAnalysisFiles.push(...res.data);
        });
      }
    },
    eventDisableDate(index) {
      let that = this;
      return (date) => {
        if (commonFun.isNotEmpty(that.formData.events[index].startDate)) {
          return date < that.formData.events[index].startDate;
        }
      }
    },
    eventDisableStartDate(index) {
      let that = this;
      return (date) => {
        if (commonFun.isNotEmpty(that.formData.events[index].deadline)) {
          return date > that.formData.events[index].deadline;
        }
      }
    },
    formatSsrData() {
      let ssr = JSON.parse(JSON.stringify(this.formData));
      ssr.type = this.type;
      this.informationList.forEach(information => {
        ssr[information.code] = 'N';
      })
      this.$refs.informationList.selection.forEach(information => {
        ssr[information.code] = 'Y';
      });
      if (ssr.needCostBreakdown == 'Y') {
        ssr.costBreakdownColumns = this.costBreakdownList.map(value => value.name == null ? " " : value.name);
      }
      ssr.productSpec = this.uploadSpec ? 'Y' : 'N';
      ssr.ssrCqs = this.correspondingList;
      if (commonFun.isNotEmpty(ssr.ssrRounds)) {
        ssr.ssrRounds.forEach(round => {
          if (round.ssrRoundSupplierPqcps != null) {
            round.ssrRoundSupplierPqcps.forEach(pqcp => {
              pqcp.supplierDc = JSON.stringify(pqcp.supplierDc);
            });
          }
          if (round.ssrRoundSupplierPcns != null) {
            round.ssrRoundSupplierPcns.forEach(pcn => {
              pcn.supplierDc = JSON.stringify(pcn.supplierDc);
            })
          }
        });
      }
      return ssr;
    }
  },
  watch: {
    needReload(needReload) {
      if (needReload) {
        this.$store.dispatch("loadPre");
        this.init();
      }
    },
    formData(v) {
      var that = this;
      this.$emit("input", that.formData);
    },
    costBreakdownList: {
      handler(newValue, oldValue) {
        this.formData.costBreakdownColumns = this.costBreakdownList.map(value => value.name == null ? " " : value.name);
      },
      deep: true
    },
    showCostBreakdown(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.costBreakdownList = [
          { name: 'Item Name' },
          { name: 'Item Code' },
          { name: 'Unit（SU）' },
          { name: 'Raw Material' },
          { name: 'Packaging' },
          { name: 'Production Cost' },
          { name: 'Labor Cost' },
          { name: 'Management Cost' },
          { name: 'Tax Amount' },
          { name: 'Margin' },
          { name: 'Freight' },
          { name: 'Total Cost' },
        ];
      }
    }
  }
}
</script>
<style scoped>
.total {
  padding-left: 48px;
  width: 200px;
  display: inline-block;
  font-size: 14px;
  color: #606266;
}
</style>
